/* eslint-disable */
import React, { Component } from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { Helmet } from 'react-helmet';

import LoginModal from '../_components/loginModal';
import * as globalActions from '../../actions/global';
import Toast from '../_components/toast';
import selector from './selector';
import '../../main.scss';
import './index.scss';
const footerImage = require('../../assets/images/house-tops-bg.jpg');
const logoutImage = require('../../assets/images/sign-out-solid.svg');
const footerImageLoading = require('../../assets/images/updating-properties.gif');

class App extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    config: PropTypes.object.isRequired,
    fetchClientConfig: PropTypes.func.isRequired,
    fetchToken: PropTypes.func.isRequired,
    history: PropTypes.object,
    importStatus: PropTypes.string,
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    office: PropTypes.string.isRequired,
    token: PropTypes.string,
    user: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.initToken();
    this.gaInitialized = false;
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.token !== nextProps.token) {
      try {
        await this.props.fetchClientConfig();
      } catch (err) {
        this.props.history.push('/maintenance');
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { config } = this.props;
    if (config !== prevProps.config) {
      const configJs = (config && config.get('data') && config.get('data').toJS()) || {};
      if (
        configJs.useGoogleAnalytics &&
        configJs.googleAnalyticsID &&
        configJs.googleAnalyticsID.length &&
        !this.gaInitialized
      ) {
        new Promise(resolve => {
          ((i, s, o, g, r, a, m) => {
            i.GoogleAnalyticsObject = r;
            (i[r] = i[r] || function () {
              (i[r].q = i[r].q || []).push(arguments);
            }),
              (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            a.addEventListener('load', resolve);
            m.parentNode.insertBefore(a, m);
          })(
            window,
            document,
            'script',
            'https://www.google-analytics.com/analytics.js',
            'ga',
          );
          window.ga('create', configJs.googleAnalyticsID, 'auto');
          window.ga('send', 'pageview');
        }).then(() => {
          ReactGA.initialize(configJs.googleAnalyticsID, {
            standardImplementation: true,
          });
          this.gaInitialized = true;
        });
      }
    }
  }

  initToken() {
    const { fetchToken, office } = this.props;
    fetchToken(office);
    setTimeout(() => this.initToken(), 270000); // 4 mins 30 s
  }

  render() {
    const {
      children,
      token,
      config,
      login,
      logout,
      user,
      importStatus
    } = this.props;
    const configJs =
      (config && config.get('data') && config.get('data').toJS()) || {};
    const importStatusJs = importStatus && importStatus.get('data');
    ReactGA.pageview(window.location.pathname + window.location.search);

    return (
      <div className='wrap-container'>
        {
          configJs.useGoogleAnalytics &&
            configJs.googleAnalyticsID &&
            configJs.googleAnalyticsID.length ?
            <Helmet>

              <script async src={`https://www.googletagmanager.com/gtag/js?id=${configJs.googleAnalyticsID}`} />
              <script>
                {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${configJs.googleAnalyticsID}');
                `}

              </script>
            </Helmet> : null
        }
        {user && Object.keys(user).length ? (
          <div className='logout'>
            <a href='#' style={{ color: 'white' }} onClick={() => logout()}>
              {
                window.innerWidth > 768 ? 'Logout' :
                  <img src={logoutImage} />
              }
            </a>
          </div>
        ) : null}
        {token ? (
          children
        ) : (
          <div className='example-loading example-well h-150 vertical-align text-center'>
            <div className='loader vertical-align-middle loader-round-circle' />
          </div>
        )}
        <div className='footer-image-container'>
          <img
            src={
              importStatusJs === 'In Progress'
                ? footerImageLoading
                : footerImage
            }
          />
          <div className='footer'>
            <div>
              <span>{configJs.footerMessage}</span>
            </div>
            <div>
              <span style={{ marginRight: '5px' }}>Powered by: &#32;</span>
              <span>
                {' '}&#60;<a href='http://trueprodigy.com/'>True Prodigy</a>&#62;
              </span>
            </div>
          </div>
        </div>
        {configJs.authenticateUser === 1 && !Object.keys(user).length ? (
          <LoginModal
            config={configJs}
            login={login}
            open={configJs.authenticateUser}
          />
        ) : null}
        <Toast />
      </div>
    );
  }
}

const enhance = compose(
  withRouter,
  connect(selector, {
    fetchToken: globalActions.fetchToken,
    fetchClientConfig: globalActions.fetchClientConfig,
    login: globalActions.login,
    logout: globalActions.logout
  })
);

export default enhance(App);
